<template>
  <layout-basic>
    <v-container id="notification-sec">
      <v-row>
        <v-col md="6" class="Full-Course-Library-Title"> Notification Settings </v-col>
        <v-col md="6" class="pa-0">
          <v-card flat>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" outlined @click.prevent="showEnrolPanel" class="mr-5" v-on="on">
                    <v-icon class="mr-1" small>fa-plus</v-icon>Allocate
                    Notifications
                  </v-btn>
                </template>
<span>Allocate the notifications settings to the following
  accounts.</span>
</v-tooltip> -->
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <div class="btn-info-container mt-5">

        <v-btn class="btn btn-primary add-course-button" v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else
          class="btn btn-primary text-right add-course-button"
          :color="$globalConfig.APP_NAME === 'senso' ? 'dark-blue' : 'white'" @click="handleSaveNotificationSettings"
          outlined>Save</v-btn>

        <v-alert color="#FFF6E7" class="custom-border custom-msg-alert" variant="outlined">
          <template v-slot:prepend> <i class="fas fa-triangle-exclamation"
              style="color: #f5a623; font-size: 20px; margin-right: 16px;"></i> </template>
          <b>Important:</b> Please save your changes to notification settings before leaving the
          page, as unsaved changes will be lost.
          Also note, any notification pushed by the partner will override the company’s notification settings.
        </v-alert>

        <v-alert color="#FFF6E7" class="custom-border custom-msg-alert" variant="outlined">
          <template v-slot:prepend> <i class="fas fa-lightbulb-on"
              style="color: #f5a623; font-size: 20px; margin-right: 16px;"></i> </template>
          <b>Tips:</b> Use merge fields to automatically insert details such as the learner’s name, course name, or
          deadline
          date into your message. For example, Hi <b v-pre>{{FirstName}}</b> will appear as Hi <b>John</b> in the actual
          notification.
        </v-alert>
      </div>
      <v-row class="mb-5">
        <v-col md="12" class="pt-4" cols="12">
          <v-form ref="form">
            <!-- <v-radio-group v-model="getBy" row>
              <strong class="grey800--text">Who gets the notifications?</strong>
              <v-radio label="Admin" value="1" class="pl-4"></v-radio>
              <v-radio label="User" value="2"></v-radio>
              <v-radio label="Both" value="3"></v-radio>
            </v-radio-group> -->
            <v-radio-group v-model="shownUp" row>
              <strong class="grey800--text">How would you like to send the notifications?</strong>
              <v-radio label="Email" value="1" class="pl-4"></v-radio>
              <v-radio label="Platform" value="2"></v-radio>
              <v-radio label="Both" value="3"></v-radio>
            </v-radio-group>
            <v-row>
              <hr style="width: 100%; height: 2px" v-if="allowCustomization" />
              <div class="notification-edit-container" v-show="allowCustomization">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.customized_notification" class="input_switch"
                     hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Customized your notifications</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div :class="['tooltip-textarea', { 'not-allowed': !this.notification.customized_notification }]">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>The header logo will be displayed at the top of all notifications.</span>
                    </v-tooltip>
                    <template style="padding:0px !important" class="notification-content">
                      <drop-zone :type="headerType" :accepted="accepted" class="dropzone-container header-logo"
                        text="Upload Header Logo" :error-messages="messages.s3_url"
                        :style="{ pointerEvents: !this.notification.customized_notification ? 'none' : 'auto' }"
                        :image.sync="this.notificationContent.header_logo" :dropzone-id="'headerLogo'">
                      </drop-zone>
                      <p class="block text-left mt-4 caption">
                        Max upload filesize: 10MB <br />
                        Recommended Dimensions: 180 × 50px<br />
                        Accepted file formats: png, jpg
                      </p>
                    </template>
                  </div>
                  <div :class="['tooltip-textarea mt-5', { 'not-allowed': !this.notification.customized_notification }]">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>This image will be displayed at the bottom of all notifications.</span>
                    </v-tooltip>
                    <template style="padding:0px !important" class="notification-content">
                      <drop-zone :type="footerType" :accepted="accepted" class="dropzone-container footer-image"
                        text="Upload Footer Image" :error-messages="messages.s3_url"
                        :style="{ pointerEvents: !this.notification.customized_notification ? 'none' : 'auto' }"
                        :image.sync="this.notificationContent.footer_logo" :dropzone-id="'footerLogo'">
                      </drop-zone>
                      <p class="block text-left mt-4 caption">
                        Max upload filesize: 10MB <br />
                        Recommended Dimensions: 600 × 250px<br />
                        Accepted file formats: png, jpg
                      </p>
                    </template>
                  </div>
                  <div class="tooltip-textarea mt-5">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>Buttons that appear in notifications can be customised.</span>
                    </v-tooltip>
                    <template style="padding:0px !important" class="notification-content">

                      <!-- Example Button Preview -->
                      <v-btn class="mr-6"
                        :style="{ backgroundColor: notificationContent.button_colour, color: notificationContent.text_colour }">
                        Example Button
                      </v-btn>

                      <!-- Button Colour Picker -->
                      <v-text-field v-model="notificationContent.button_colour" label="Button Colour"
                        class="mr-4 color-input" hide-details dense outlined readonly>
                        <template v-slot:append>
                          <v-menu  v-model="menuButton" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290"
                            min-width="290" :disabled="!notification.customized_notification">
                            <template v-slot:activator="{ on, attrs }">
                              <v-avatar v-bind="attrs" v-on="on" size="24"
                                :style="{ backgroundColor: notificationContent.button_colour, cursor: 'pointer' }"
                                class="color-circle"></v-avatar>
                            </template>

                            <v-card>
                              <v-color-picker v-model="notificationContent.button_colour" hide-mode-switch flat
                                mode="hexa" value></v-color-picker>
                            </v-card>
                          </v-menu>
                        </template>
                      </v-text-field>

                      <!-- Text Colour Picker -->
                      <v-text-field v-model="notificationContent.text_colour" label="Text Colour" class="color-input"
                        hide-details dense outlined readonly>
                        <template v-slot:append>
                          <v-menu v-model="menuText" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290"
                            min-width="290" :disabled="!notification.customized_notification">
                            <template v-slot:activator="{ on, attrs }">
                              <v-avatar v-bind="attrs" v-on="on" size="24"
                                :style="{ backgroundColor: notificationContent.text_colour, cursor: 'pointer' }"
                                class="color-circle"></v-avatar>
                            </template>

                            <v-card>
                              <v-color-picker v-model="notificationContent.text_colour" hide-mode-switch flat
                                mode="hexa"></v-color-picker>
                            </v-card>
                          </v-menu>
                        </template>
                      </v-text-field>

                    </template>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.welcome_mail" class="input_switch" 
                     @change="toggleFieldValidation('welcome_mail')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Enable Welcome Email Notification</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div class="tooltip-textarea">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>Notify users when a new account is created for them.</span>
                    </v-tooltip>
                    <div style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 11)"
                        :disabled="!notification.welcome_mail" :items="WelcomeUserMergeFields"
                        label="Insert Merge Field" density="comfortable" v-model="selectedMergeField[11]" outlined
                        hide-details="auto"></v-select>
                      <v-input
                        :rules="[v => customMessageRule(v, notification.welcome_mail, ['{{SetPasswordButton}}'])]"
                        hide-details="auto" required class="notification-textarea"
                        v-model="notificationContent.welcome_mail">
                        <ckeditor :editor="editor" class="notification-ckeditor" ref="welcome_mail"
                          v-model="notificationContent.welcome_mail" tag-name="textarea" :config="editorConfig"
                          @ready="onEditorReady($event, 11)"
                          :label="notification.welcome_mail ? 'Add a custom notification message' : 'Enable to add a custom message'"
                          :disabled="!notification.welcome_mail" style="min-height:200px;">
                        </ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Welcome Mail', notificationContent.welcome_mail)"
                        :class="['preview-icon-wrapper', { disabled: !notification.welcome_mail }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </div>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.reset_password" class="input_switch" 
                     @change="toggleFieldValidation('reset_password')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Enable Reset Password Email Notification</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div class="tooltip-textarea">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>Notify users when they request a password reset.</span>
                    </v-tooltip>
                    <div style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 12)"
                        :disabled="!notification.reset_password" :items="ResetPasswordMergeFields"
                        label="Insert Merge Field" density="comfortable" v-model="selectedMergeField[12]" outlined
                        hide-details="auto"></v-select>
                      <v-input
                        :rules="[v => customMessageRule(v, notification.reset_password, ['{{SetPasswordButton}}'])]"
                        hide-details="auto" required class="notification-textarea"
                        v-model="notificationContent.reset_password">
                        <ckeditor :editor="editor" class="notification-ckeditor" ref="reset_password"
                          v-model="notificationContent.reset_password" tag-name="textarea" :config="editorConfig"
                          @ready="onEditorReady($event, 12)"
                          :label="notification.reset_password ? 'Add a custom notification message' : 'Enable to add a custom message'"
                          :disabled="!notification.reset_password" style="min-height:200px;">
                        </ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Reset Password', notificationContent.reset_password)"
                        :class="['preview-icon-wrapper', { disabled: !notification.reset_password }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </div>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.course_assign" class="input_switch"
                    @change="toggleFieldValidation('course_assign')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Enable notification on new course
                          assignment</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">

                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>Notify users when a new course is assigned to them.</span>
                    </v-tooltip>
                    <v-container style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 0)" :disabled="!notification.course_assign"
                        :items="courseMergeFields" label="Insert Merge Field" density="comfortable"
                        v-model="selectedMergeField[0]" outlined hide-details="auto"></v-select>
                      <v-input :rules="[v => customMessageRule(v, notification.course_assign, ['{{CourseName}}'])]" hide-details="auto"
                        required class="notification-textarea" v-model="notificationContent.course_assign">
                        <ckeditor :editor="editor" class="notification-ckeditor" ref="course_assign"
                          v-model="notificationContent.course_assign" tag-name="textarea" :config="editorConfig"
                          @ready="onEditorReady($event, 0)"
                          :label="notification.course_assign ? 'Add a custom notification message' : 'Enable to add a custom message'"
                          :disabled="!notification.course_assign" style="min-height:200px;"></ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Course Assign', notificationContent.course_assign)"
                        :class="['preview-icon-wrapper', { disabled: !notification.course_assign }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </v-container>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.playlist_assign" class="input_switch"
                    @change="toggleFieldValidation('playlist_assign')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Enable notification on new playlist
                          assignment</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>Notify users when a new playlist is assigned to them.</span>
                    </v-tooltip>
                    <v-container style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 1)" :disabled="!notification.playlist_assign"
                        :items="playlistMergeFields" label="Insert Merge Field" density="comfortable"
                        v-model="selectedMergeField[1]" outlined hide-details="auto"></v-select>
                      <v-input :rules="[v => customMessageRule(v, notification.playlist_assign, ['{{PlaylistName}}'])]" hide-details="auto"
                        required class="notification-textarea" v-model="notificationContent.playlist_assign">
                        <ckeditor :editor="editor" class="notification-ckeditor"
                          :disabled="!notification.playlist_assign" v-model="notificationContent.playlist_assign"
                          tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 1)"
                          ref="playlist_assign"
                          :label="notification.playlist_assign ? 'Add a custom notification message' : 'Enable to add a custom message'"
                          style="min-height:200px;"></ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Playlist Assign', notificationContent.playlist_assign)"
                        :class="['preview-icon-wrapper', { disabled: !notification.playlist_assign }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </v-container>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.deadline_set" class="input_switch"
                    @change="toggleFieldValidation('deadline_set')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Enable notification on deadline set</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>Notify users when a deadline is set on courses they are assigned to.</span>
                    </v-tooltip>
                    <v-container style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 2)" :disabled="!notification.deadline_set"
                        :items="deadlineMergeFields" label="Insert Merge Field" density="comfortable"
                        v-model="selectedMergeField[2]" outlined hide-details="auto"></v-select>
                      <v-input :rules="[v => customMessageRule(v, notification.deadline_set, ['{{CourseName}}','{{DeadlineDate}}'])]" hide-details="auto"
                        required class="notification-textarea" v-model="notificationContent.deadline_set">
                        <ckeditor :editor="editor" class="notification-ckeditor" :disabled="!notification.deadline_set"
                          v-model="notificationContent.deadline_set" tag-name="textarea" :config="editorConfig"
                          @ready="onEditorReady($event, 2)" ref="deadline_set"
                          :label="notification.deadline_set ? 'Add a custom notification message' : 'Enable to add a custom message'">
                        </ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Deadline Set', notificationContent.deadline_set)"
                        :class="['preview-icon-wrapper', { disabled: !notification.deadline_set }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </v-container>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.deadline_changed" class="input_switch"
                    @change="toggleFieldValidation('deadline_changed')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Enable notification on deadline changed</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>Notify users when a deadline of a course they are assigned to is changed.</span>
                    </v-tooltip>
                    <v-container style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 3)" :disabled="!notification.deadline_changed"
                        :items="deadlineMergeFields" label="Insert Merge Field" density="comfortable"
                        v-model="selectedMergeField[3]" outlined hide-details="auto"></v-select>
                      <v-input :rules="[v => customMessageRule(v, notification.deadline_changed, ['{{CourseName}}','{{DeadlineDate}}'])]" hide-details="auto"
                        required class="notification-textarea" v-model="notificationContent.deadline_changed">
                        <ckeditor :editor="editor" class="notification-ckeditor"
                          :disabled="!notification.deadline_changed" v-model="notificationContent.deadline_changed"
                          tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 3)"
                          ref="deadline_changed"
                          :label="notification.deadline_changed ? 'Add a custom notification message' : 'Enable to add a custom message'">
                        </ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Deadline Changed', notificationContent.deadline_changed)"
                        :class="['preview-icon-wrapper', { disabled: !notification.deadline_changed }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </v-container>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.missed_deadline" class="input_switch"
                    @change="toggleFieldValidation('missed_deadline')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Enable notification on missed deadline</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>Notify users when they miss the deadline for an assigned course.</span>
                    </v-tooltip>
                    <v-container style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 4)" :disabled="!notification.missed_deadline"
                        :items="deadlineMergeFields" label="Insert Merge Field" density="comfortable"
                        v-model="selectedMergeField[4]" outlined hide-details="auto"></v-select>
                      <v-input :rules="[v => customMessageRule(v, notification.missed_deadline, ['{{CourseName}}','{{DeadlineDate}}'])]" hide-details="auto"
                        required class="notification-textarea" v-model="notificationContent.missed_deadline">
                        <ckeditor :editor="editor" class="notification-ckeditor"
                          :disabled="!notification.missed_deadline" v-model="notificationContent.missed_deadline"
                          tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 4)"
                          ref="missed_deadline"
                          :label="notification.missed_deadline ? 'Add a custom notification message' : 'Enable to add a custom message'">
                        </ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Missed Deadline', notificationContent.missed_deadline)"
                        :class="['preview-icon-wrapper', { disabled: !notification.missed_deadline }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </v-container>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.auto_archived" class="input_switch"
                    @change="toggleFieldValidation('auto_archived')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Enable notification on Auto Archive course data</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>Notify users when a course assigned to them gets auto archived.</span>
                    </v-tooltip>
                    <v-container style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 5)" :disabled="!notification.auto_archived"
                        :items="courseMergeFields" label="Insert Merge Field" density="comfortable"
                        v-model="selectedMergeField[5]" outlined hide-details="auto"></v-select>
                      <v-input :rules="[v => customMessageRule(v, notification.auto_archived, ['{{CourseName}}'])]" hide-details="auto"
                        required class="notification-textarea" v-model="notificationContent.auto_archived">
                        <ckeditor :editor="editor" class="notification-ckeditor" :disabled="!notification.auto_archived"
                          v-model="notificationContent.auto_archived" tag-name="textarea" :config="editorConfig"
                          @ready="onEditorReady($event, 5)" ref="auto_archived"
                          :label="notification.auto_archived ? 'Add a custom notification message' : 'Enable to add a custom message'">
                        </ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Auto Archived', notificationContent.auto_archived)"
                        :class="['preview-icon-wrapper', { disabled: !notification.auto_archived }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </v-container>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3">
                  <div>
                    <strong class="grey800--text">Send a notification [X] days before the deadline:</strong>
                  </div>
                </v-col>
                <v-col sm="12" md="2">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>How many days in advance should users be notified before an assigned course deadline?</span>
                    </v-tooltip>
                    <v-text-field :error-messages="messages.deadline_before" v-model="notification.deadline_before"
                      type="number" :min="0" :max="30" outlined @keypress="NumbersOnly"
                      @blur="handleBlur('deadline_before')" hide-details="auto">
                    </v-text-field>
                  </div>
                </v-col>

                <v-col sm="12" md="6">
                  <v-container style="padding:0px !important" class="notification-content">
                    <!-- Merge Fields Dropdown -->
                    <v-select @change="insertMergeField($event, 6)" :items="deadlineMergeFields"
                      label="Insert Merge Field" density="comfortable" v-model="selectedMergeField[6]" outlined
                      hide-details="auto"></v-select>
                    <v-input :rules="[v => customMessageRule(v, notification.deadline_before, ['{{CourseName}}','{{DeadlineDate}}'])]" hide-details="auto"
                      required class="notification-textarea" v-model="notificationContent.deadline_before">
                      <ckeditor :editor="editor" class="notification-ckeditor"
                        v-model="notificationContent.deadline_before" tag-name="textarea" :config="editorConfig"
                        @ready="onEditorReady($event, 6)" ref="deadline_before"
                        label="Add a custom notification message"></ckeditor>
                    </v-input>
                    <span @click.stop="preivewNotification('Deadline Before', notificationContent.deadline_before)"
                        :class="['preview-icon-wrapper', { disabled: !notification.deadline_before }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                  </v-container>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3">
                  <div>
                    <strong class="grey800--text">Send a notification to idle user after [X] days:</strong>
                  </div>
                </v-col>
                <v-col sm="12" md="2">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>After how many days of inactivity should users be notified if they haven’t started a
                        course?</span>
                    </v-tooltip>
                    <v-text-field v-model="notification.idle_after" :error-messages="messages.idle_after" type="number"
                      :min="0" :max="30" outlined @keypress="NumbersOnly" @blur="handleBlur('idle_after')"
                      hide-details="auto">
                    </v-text-field>
                  </div>
                </v-col>
                <v-col sm="12" md="6">
                  <v-container style="padding:0px !important" class="notification-content">
                    <!-- Merge Fields Dropdown -->
                    <v-select @change="insertMergeField($event, 7)" :items="courseMergeFields" label="Insert Merge Field"
                      density="comfortable" v-model="selectedMergeField[7]" outlined hide-details="auto"></v-select>
                    <v-input :rules="[v => customMessageRule(v, notification.idle_after, ['{{CourseName}}'])]" hide-details="auto" required
                      class="notification-textarea" v-model="notificationContent.idle_after">
                      <ckeditor :editor="editor" class="notification-ckeditor" v-model="notificationContent.idle_after"
                        tag-name="textarea" :config="editorConfig" @ready="onEditorReady($event, 7)" ref="idle_after"
                        label="Add a custom notification message"></ckeditor>
                    </v-input>
                    <span @click.stop="preivewNotification('Idle After', notificationContent.idle_after)"
                        :class="['preview-icon-wrapper', { disabled: !notification.idle_after }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                  </v-container>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3">
                  <div>
                    <strong class="grey800--text">Send a notification [X] days before external training
                      deadline:</strong>
                  </div>
                </v-col>
                <v-col sm="12" md="2">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>When external training is allocated to a user, how many days in advance should users be
                        notified before an assigned course deadline?</span>
                    </v-tooltip>
                    <v-text-field v-model="notification.external_deadline_before"
                      :error-messages="messages.external_deadline_before" type="number" :min="0" :max="30" outlined
                      @keypress="NumbersOnly" @blur="handleBlur('external_deadline_before')" hide-details="auto">
                    </v-text-field>
                  </div>
                </v-col>
                <v-col sm="12" md="6">
                  <v-container style="padding:0px !important" class="notification-content">
                    <!-- Merge Fields Dropdown -->
                    <v-select @change="insertMergeField($event, 8)" :items="externalTrainingDeadlineMergeFields"
                      label="Insert Merge Field" density="comfortable" v-model="selectedMergeField[8]" outlined
                      hide-details="auto"></v-select>
                    <v-input :rules="[v => customMessageRule(v, notification.external_deadline_before, ['{{CourseName}}','{{DeadlineDate}}'])]"
                      hide-details="auto" required class="notification-textarea"
                      v-model="notificationContent.external_deadline_before">
                      <ckeditor :editor="editor" class="notification-ckeditor"
                        v-model="notificationContent.external_deadline_before" tag-name="textarea"
                        :config="editorConfig" @ready="onEditorReady($event, 8)" ref="external_deadline_before"
                        label="Add a custom notification message"></ckeditor>
                    </v-input>
                    <span @click.stop="preivewNotification('External Deadline Before', notificationContent.external_deadline_before)"
                        :class="['preview-icon-wrapper', { disabled: !notification.external_deadline_before }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                  </v-container>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <v-col cols="12" class="Full-Course-Library-Title">
                Company Admin Notifications
              </v-col>
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.course_status_changed" class="input_switch"
                    @change="toggleFieldValidation('course_status_changed')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Notify admin when a user starts a course</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>When a user starts a course assigned by a company admin, the admin will receive a
                        notification</span>
                    </v-tooltip>
                    <v-container style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 9)" :disabled="!notification.course_status_changed"
                        :items="adminMergeFields" label="Insert Merge Field" density="comfortable"
                        v-model="selectedMergeField[9]" outlined hide-details="auto"></v-select>
                      <v-input :rules="[v => customMessageRule(v, notification.course_status_changed,['{{CourseName}}','{{Email}}'])]"
                        hide-details="auto" required class="notification-textarea"
                        v-model="notificationContent.course_status_changed">
                        <ckeditor :editor="editor" class="notification-ckeditor" ref="course_status_changed"
                          v-model="notificationContent.course_status_changed" tag-name="textarea" :config="editorConfig"
                          @ready="onEditorReady($event, 9)"
                          :label="notification.course_status_changed ? 'Add a custom notification message' : 'Enable to add a custom message'"
                          :disabled="!notification.course_status_changed"></ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Course Status Changed', notificationContent.course_status_changed)"
                        :class="['preview-icon-wrapper', { disabled: !notification.course_status_changed }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </v-container>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.course_completion" class="input_switch"
                    @change="toggleFieldValidation('course_completion')" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Notify admin when a user completes a
                          course</strong>
                      </div>
                    </template>
                  </v-switch>
                </v-col>
                <v-col sm="12" md="6">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="mr-2">fa fa-question</v-icon>
                      </template>
                      <span>When a user completes a course assigned by a company admin, the admin will receive a
                        notification.</span>
                    </v-tooltip>
                    <v-container style="padding:0px !important" class="notification-content">
                      <!-- Merge Fields Dropdown -->
                      <v-select @change="insertMergeField($event, 10)" :disabled="!notification.course_completion"
                        :items="adminMergeFields" label="Insert Merge Field" density="comfortable"
                        v-model="selectedMergeField[10]" outlined hide-details="auto"></v-select>
                      <v-input :rules="[v => customMessageRule(v, notification.course_completion,['{{CourseName}}','{{Email}}'])]" hide-details="auto"
                        required class="notification-textarea" v-model="notificationContent.course_completion">
                        <ckeditor :editor="editor" class="notification-ckeditor" ref="course_completion"
                          v-model="notificationContent.course_completion" tag-name="textarea" :config="editorConfig"
                          @ready="onEditorReady($event, 10)"
                          :label="notification.course_completion ? 'Add a custom notification message' : 'Enable to add a custom message'"
                          :disabled="!notification.course_completion"></ckeditor>
                      </v-input>
                      <span @click.stop="preivewNotification('Course Completion', notificationContent.course_completion)"
                        :class="['preview-icon-wrapper', { disabled: !notification.course_completion }]">
                        <img src="/static/preview-icon.svg" class="preview-icon" alt="" />
                      </span>
                    </v-container>
                  </div>
                </v-col>
              </div>
              <hr style="width: 100%; height: 2px" />
              <v-col cols="12" class="Full-Course-Library-Title">
                Notification Access
              </v-col>
              <div class="notification-edit-container">
                <v-col sm="12" md="3" class="notification-switch">
                  <v-switch v-model="notification.admin_setting" class="input_switch" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong class="grey800--text">Can admin overwrite this setting</strong>
                      </div>
                    </template>
                  </v-switch>
                  <div class="ml-5" v-if="$vuetify.breakpoint.smAndDown">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">fa fa-question</v-icon>
                      </template>
                      <span>To enable the admin to overwrite setting you have set,
                        please slide the button to publish</span>
                    </v-tooltip>
                  </div>
                </v-col>
                <v-col sm="12" md="6" v-if="$vuetify.breakpoint.mdAndUp">
                  <div class="tooltip-textarea">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">fa fa-question</v-icon>
                      </template>
                      <span>To enable the admin to overwrite setting you have set,
                        please slide the button to publish</span>
                    </v-tooltip>
                  </div>
                </v-col>
              </div>
            </v-row>
            <br />
          </v-form>
        </v-col>
      </v-row>
    </v-container>
     <PreviewDialog
        :isOpen="dialog"
        :dialogTitle="dialogTitle"
        :dialogData="dialogData"
        :headerImgSrc="headerImgSrc"
        :footerImgSrc="footerImgSrc"
        @close="closeDialog"
        />
  </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/PartnerHub';
import notificationAPI from '@/api/notification.js';
import EditNotificationMsg from '@/components/partner/notification/EditNotificationMsg';
import EnrolUsers from '@/components/partner/notification/Customer';
import { EventBus } from '@/event-bus.js';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DropZone from "@/components/global/Dropzone";
import PreviewDialog from '@/components/PreviewDialog';

export default {
  name: 'Profile',
  components: {
    LayoutBasic,
    DropZone,
    PreviewDialog,
  },
  data() {
    return {
      company: [],
      notification: {},
      notificationContent: {},
      params: '',
      messages: {},
      getBy: '',
      shownUp: '',
      successMessage: 'Notification Settings Successfully Updated.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      default_admin_setting: 0,
      loading: false,
      editorConfig: {
        placeholder: 'Type your custom notification message here...', // <-- placeholder here
        toolbar: {
          items: [
            'undo', 'redo',
            '|', 'heading',
            '|', 'bold', 'italic',
            '|', 'bulletedList', 'numberedList',
            '|', 'link'
          ]
        },
      },
      editor: ClassicEditor,
      editors: [
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
        { content: "", instance: null },
      ],
      WelcomeUserMergeFields:[
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{Email}}", value: "{{Email}}" },
        { text: "{{SetPasswordButton}}", value: "{{SetPasswordButton}}" },
      ],
      ResetPasswordMergeFields:[
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{SetPasswordButton}}", value: "{{SetPasswordButton}}" },
      ],
      courseMergeFields: [
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{CourseName}}", value: "{{CourseName}}" },
        { text: "{{CourseLink}}", value: "{{CourseLink}}" },
      ],
      playlistMergeFields: [
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{PlaylistName}}", value: "{{PlaylistName}}" },
        { text: "{{PlaylistLink}}", value: "{{PlaylistLink}}" },
      ],
      deadlineMergeFields: [
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{CourseName}}", value: "{{CourseName}}" },
        { text: "{{DeadlineDate}}", value: "{{DeadlineDate}}" },
        { text: "{{CourseLink}}", value: "{{CourseLink}}" },
      ],
      externalTrainingDeadlineMergeFields: [
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{CourseName}}", value: "{{CourseName}}" },
        { text: "{{DeadlineDate}}", value: "{{DeadlineDate}}" },
      ],
      adminMergeFields: [
        { text: "Select a merge field...", value: null },
        { text: "{{FirstName}}", value: "{{FirstName}}" },
        { text: "{{LastName}}", value: "{{LastName}}" },
        { text: "{{Email}}", value: "{{Email}}" },
        { text: "{{CourseName}}", value: "{{CourseName}}" },
      ],
      selectedMergeField: [], // keep array if you have multiple editors
      headerType: "header-email-logo",
      footerType: "footer-email-logo",
      accepted: "image/jpg,image/jpeg,image/png",
      buttonColor: '',
      textColor: '',
      menuButton: false,
      menuText: false,
      dialog: false,
      dialogTitle : '',
      dialogData: '',
      headerImgSrc: '',
      footerImgSrc: '',
      companyId: this.$route.params.id,
      allowCustomization: 0
    };
  },
   watch: {
    editorData(newVal) {
      this.$emit('input', newVal)
    },
  },
  computed: {
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    },
  },
  mounted() {
    this.getNotificationSettings();
  },
  methods: {
    getNotificationSettings() {
      notificationAPI.getNotificationSettingsWithContent('?companyId='+this.companyId).then((resp) => {
        if (resp.data.data.settings.length !== 0) {
          this.notification = resp.data.data.settings;
          this.default_admin_setting = this.notification.admin_setting;
          if (this.notification.notification_get_by == 1) this.getBy = '1';
          else if (this.notification.notification_get_by == 2) this.getBy = '2';
          else this.getBy = '3';

          if (this.notification.notification_shown_up == 1) this.shownUp = '1';
          else if (this.notification.notification_shown_up == 2)
            this.shownUp = '2';
          else this.shownUp = '3';
        } else {
          this.getBy = '2';
          this.shownUp = '3';
          this.default_admin_setting = '0';
        }
        this.notificationContent = resp.data.data.content;
        this.buttonColor = this.notificationContent.button_colour;
        this.textColor = this.notificationContent.text_colour;
        this.allowCustomization = resp.data.data.allow_customiztion;
        if(this.allowCustomization){
          this.$store.dispatch('setDropzoneLoaded', { id: 'headerLogo', value: true });
          this.$store.dispatch('setDropzoneLoaded', { id: 'footerLogo', value: true });
        }
        
      });
    },
    editNotificationMsg(type) {
      this.$showPanel({
        component: EditNotificationMsg,
        props: {
          type: type,
          admin_setting: this.default_admin_setting,
        },
        openOn: 'right',
      });
    },
    handleSaveNotificationSettings() {
      this.$snotify.confirm('Are you sure you want to save the changes?', {
        backdrop: 0.3,
        buttons: [
          { text: "No", className: 'toast-cancel-button' },
          {
            text: "Yes", className: 'toast-continue-button',
            action: toast => this.AddUpdateNotificationSetting()
          }          
        ]
      });
    },
    AddUpdateNotificationSetting() {
      this.$snotify.remove(); // Remove the confirmation toast
      const backdrop = document.querySelector('.snotify-backdrop');
      if (backdrop) {
          backdrop.parentNode.removeChild(backdrop);
      }
      this.loading = true;
      if (this.$refs.form.validate()) {
        notificationAPI
          .addUpdateNotificationSettingsWithContent(
            this.notification,
            this.notificationContent,
            this.getBy,
            this.shownUp,
            this.$store.getters.headerS3Url,
            this.$store.getters.headerFileDetails,
            this.$store.getters.footerS3Url,
            this.$store.getters.footerFileDetails,
            this.companyId
          )
          .then(() => {
            this.$snotify.success(this.successMessage);
            EventBus.$emit('NOTIFICATION_SETTINGS_UPDATED', this.params);
            this.loading = false;
            setTimeout(() => {
              this.$gf.removeBackdrop();
            }, 300);
          })
          .catch((err) => {
            this.valid = false;
            this.messages = this.$gf.errorResponse(err);
            this.$snotify.error(this.errorMessage);
            this.loading = false;
            setTimeout(() => {
              this.$gf.removeBackdrop();
            }, 300);
          });
      } else {
        this.loading = false;
      }
    },
    showEnrolPanel() {
      this.$showPanel({
        component: EnrolUsers,
        disableBgClick: true,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleBlur(fieldName) {
      const value = parseInt(this.notification[fieldName], 10);
      if (value > 30) {
        this.notification[fieldName] = 30;
      }
    },
    customMessageRule(value, enabled, requiredFields = []) {
      if ( enabled && (this.shownUp == 1 || this.shownUp == 3)) {
          //Check empty value
          if (!value || !value.trim()) {
            return "Notification content is required.";
          }
         
           //Normalize case
          const content = value.toLowerCase();

          //Handle multiple required merge fields
          const missing = requiredFields.filter(
            (field) => !content.includes(field.toLowerCase())
          );

          //If missing any fields, return error
          if (missing.length > 0) {
            const formatted = missing.join(", ");
            return `Missing required merge field${missing.length > 1 ? "s" : ""}: ${formatted}`;
          }
      }
      return true
    },
    toggleFieldValidation(field) {
      const switchItem = this.notification[field];
      if (!switchItem) {
        this.$nextTick(() => {
          this.$refs[field].resetValidation();
        });
      }
    },
    onEditorReady(editor, index) {
      this.editors[index].instance = editor;
    },
    insertMergeField(field, index) {
      if (!field) return

      const editor = this.editors[index].instance;
      if (editor) {
        editor.model.change(writer => {
          let insertPosition = editor.model.document.selection.getLastPosition();
          // If no selection, insert at the end of document
          if (!insertPosition) {
            insertPosition = editor.model.createPositionAt(editor.model.document.getRoot(), 'end');
          }
          writer.insertText(field, insertPosition);
          // ✅ Move cursor after inserted text
          const newPosition = insertPosition.getShiftedBy(field.length);
          writer.setSelection(newPosition);
        });
        // ✅ Focus editor so user can continue typing
        editor.editing.view.focus();
      }

      // Reset ONLY this select
      this.$nextTick(() => {
        // 1) reset the v-model
        this.selectedMergeField.splice(index, 1, null);
      });
    },
    preivewNotification(title,content) {
      this.dialogTitle = title;

      if(title == 'Welcome Mail' || title == 'Reset Password'){
      // Button configuration (use whatever component/data props you already have)
      const bg = this.allowCustomization && this.notification.customized_notification ? this.notificationContent.button_colour :
                  this.$globalConfig.APP_NAME == 'senso' ? '#3497c5': '#7BC8A3';        // background color
      const fg = this.allowCustomization && this.notification.customized_notification ? this.notificationContent.text_colour : '#FFFFFF';         // text color
      const pad = this.buttonPadding || '10px 20px';  // padding
      const radius = this.buttonRadius || '4px';      // border-radius
      const label = this.buttonLabel || 'Set password';// text shown inside button

      // build replacement HTML for the merge field
      const replacement = `<a href="{{resetPasswordUrl}}" target="_blank" rel="noopener noreferrer" style="text-decoration:none;">
        <span style="background-color:${this._escapeAttr(bg)}; color:${this._escapeAttr(fg)};
                    padding:${this._escapeAttr(pad)}; border-radius:${this._escapeAttr(radius)};
                    display:inline-block; text-decoration:none;">
          ${this._escapeHtml(label)}
        </span>
      </a>`;
      const replaced = String(content).replace(/\{\{SetPasswordButton\}\}/g, replacement);
      this.dialogData = replaced;
      }else{
         this.dialogData = content;
      }
      this.dialog = true;
      if(this.allowCustomization && this.notification.customized_notification){
        this.headerImgSrc = this.$store.getters.headerS3Url ? this.$store.getters.emailHeaderLogo : '';
        this.footerImgSrc = this.$store.getters.footerS3Url  ? this.$store.getters.emailFooterLogo : '';
      }else{
        this.headerImgSrc = this.footerImgSrc = '';
      }
      const improveEl = document.getElementById('improve')
      const navbarEl = document.getElementById('navbar-collapse')
      if (improveEl) improveEl.style.pointerEvents = 'none';
      if (navbarEl) navbarEl.style.pointerEvents = 'none';
    },
    closeDialog() {
      const improveEl = document.getElementById('improve');
      const navbarEl = document.getElementById('navbar-collapse');
      if (improveEl) improveEl.style.pointerEvents = 'unset';
      if (navbarEl) navbarEl.style.pointerEvents = 'unset';
      this.dialog = false;
    },
    _escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  },

  // basic attribute escape (keeps quotes safe)
  _escapeAttr(str) {
    if (str == null) return '';
    return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
}
};
</script>

<style>
#billing-sec .v-input__slot {
  border-bottom: 0px !important;
}

.v-btn--depressed:hover {
  background-color: none;
}

#notification-sec.row:hover {
  background-color: none;
}
</style>
<!-- <style scoped>

.btn-info-container {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
}

.custom-msg-alert {
  padding: 10px;
  margin-bottom: 5px;
}

.notification-edit-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.notification-textarea {
  width: 100%;
  max-width: 600px;
  /* Optional: control size */
}

@media (max-width: 767px) {

  .btn-info-container,
  .notification-edit-container {
    display: block !important;
  }

  .custom-msg-alert {
    margin-top: 10px;
  }
  .preview-icon{
    position: unset !important;
    margin-top: 5px;
  }
}

.notification-switch {
  display: inline-flex;
}
.notification-content{
  position: relative;
  width: 600px;
}
.preview-icon{
  width: 25px;
  position: absolute;
  right: -40px;
  top: 35px;
  cursor: pointer;
}

.preview-icon-wrapper {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.preview-icon-wrapper.disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}
.header-logo{
    border: 2px dashed #9e9e9e;
    width: 65%;
    min-height: unset;
    /* height: 70px; */
}

.footer-image{
  border: 2px dashed #9e9e9e;
  width: 65%;
  min-height: unset;
  /* height: 100px; */
}

.single-button-picker {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.color-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
  transition: all 0.2s ease;
}

.color-circle:hover {
  transform: scale(1.1);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}
</style> -->

<style scoped>
.flex-end-notification {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 768px) {
  .flex-end-notification {
    justify-content: end !important;
  }
}
@media (max-width: 767px) {
  .Notification-Title{
    font-size: 18px !important;
  }
  .btn-info-container, .notification-edit-container {
    display: block !important;
  }
  .custom-msg-alert{
    margin-top: 10px;
  }
  .tooltip-textarea {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
    
  .tooltip-textarea .v-icon {
    margin-bottom: 10px;
  }
    
  .tooltip-textarea .v-input {
    width: 100%;
  }

 .tooltip-textarea .color-input {
    margin-top: 15px;
  }


  .notification-content{
    position: relative;
    width: 100% !important;
  }

  .preview-icon{
    position: unset !important;
    margin-top: 5px;
  }
  .notification-edit-container{
    width: 100% !important;
  }
  .header-logo, .footer-image{
    width: 100% !important;
  }
}
.sticky{
  position: fixed;
  top: 74px;
  right: 22px;
  z-index: 10;
  background-color: white;
  padding: 0 10px;
}

@media screen and (max-width: 960px) {
  .sticky{
    top: 64px;
  }
}

@media screen and (max-width: 460px) {
  .sticky{
    top: 115px;
    border: 1px solid #fff;
  }
}

.Notification-Title{
  width: 166px;
    font-family: Source Sans Pro;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: #162b44;
    padding-left: 12px;
    margin: 0;
    display: block;
}
.btn-info-container{
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
}
.custom-msg-alert{
  padding: 10px;
  margin-bottom: 5px;
}
.notification-edit-container{
  display: flex;
  align-items: center;
  width: 90%;
}
.notification-textarea {
  width: 100%;
  max-width: 600px; /* Optional: control size */
}
.notification-switch{
  display: inline-flex;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .notification-edit-container{
    display: block;
  }
  .tooltip-textarea {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
    
  .tooltip-textarea .v-icon {
    margin-bottom: 10px;
  }
    
  .tooltip-textarea .v-input {
    width: 100%;
  }
   .notification-content .v-select{
    width: 215px;
  }
}

@media (min-width: 820px) and (max-width: 1180px) {
  .notification-edit-container{
    display: block;
  }
 .tooltip-textarea {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
    
  .tooltip-textarea .v-icon {
    margin-bottom: 10px;
  }
    
  .tooltip-textarea .v-input {
    width: 100%;
  }
  .notification-content .v-select{
    width: 215px;
  }
}
.header-logo{
    border: 2px dashed #9e9e9e;
    width: 65%;
    min-height: unset;
    /* height: 70px; */
}

.footer-image{
  border: 2px dashed #9e9e9e;
  width: 65%;
  min-height: unset;
  /* height: 100px; */
}

.single-button-picker {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.color-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
  transition: all 0.2s ease;
}

.color-circle:hover {
  transform: scale(1.1);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}

.notification-content{
  position: relative;
  width: 600px;
}

.preview-icon{
  width: 25px;
  position: absolute;
  right: -40px;
  top: 35px;
  cursor: pointer;
}

.preview-icon-wrapper {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.preview-icon-wrapper.disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}
</style>